import { RouteConfig } from "vue-router";
import AdminToolMenu from "@/views/admin/AdminToolMenu.vue";
import DepartmentList from "@/views/admin/departments/DepartmentList.vue";
import DepartmentDetail from "@/views/admin/departments/DepartmentDetail.vue";
import AllEventList from "@/views/admin/event_metrics/AllEventList.vue";
import EventTrackList from "@/views/admin/event_metrics/EventTrackList.vue";
import LogLayout from "@/views/admin/event_metrics/log_event/LogLayout.vue";
import EventDepartmentList from "@/views/admin/event_metrics/log_event/EventDepartmentList.vue";
import LogEventList from "@/views/admin/event_metrics/log_event/LogEvents.vue";
import ArchiveEmployeeList from "@/views/admin/archive_list/ArchiveEmployeeList.vue";
import TarfHistoryLayout from "@/views/admin/tarf_history/TarfHistoryLayout.vue";
import TarfHistoryEmployeeList from "@/views/admin/tarf_history/TarfHistoryEmployeeList.vue";
import TarfHistoryStatuses from "@/views/admin/tarf_history/TarfHistoryStatuses.vue";
import TarfHistoryList from "@/views/admin/tarf_history/TarfHistoryList.vue";
import CompanyBudgetLayout from "@/views/admin/budget/CompanyBudget.vue";
import RoomSetupLayout from "@/views/admin/room_setup/RoomSetupLayout.vue";
import FloorList from "@/views/admin/room_setup/FloorList.vue";
import RoomList from "@/views/admin/room_setup/RoomList.vue";
import RoomDetails from "@/views/admin/room_setup/RoomDetails.vue";
import HandbookCategoryList from "@/views/admin/handbook/HandbookCategoryList.vue";
import HandbookCategoryDetail from "@/views/admin/handbook/HandbookCategoryDetail.vue";
import HandbookLayout from "@/views/admin/handbook/HandbookLayout.vue";
import FavoriteCategoryList from "@/views/admin/favorite_category/FavoriteCategoryList.vue";
import ShiftList from "@/views/admin/shift/ShiftList.vue";
import ShiftDetail from "@/views/admin/shift/ShiftDetail.vue";

const routes: Array<RouteConfig> = [
  {
    path: "",
    components: {
      default: AdminToolMenu,
      menu: AdminToolMenu,
      departments: DepartmentList,
      departmentDetail: DepartmentDetail,
      events: AllEventList,
      trackevents: EventTrackList,
      logevents: LogLayout,
      tarfHistory: TarfHistoryLayout,
      budget: CompanyBudgetLayout,
      roomSetup: RoomSetupLayout,
      handbookLayout: HandbookLayout,
      shiftList: ShiftList,
      shiftDetail: ShiftDetail,
    },
    meta: {
      title: "Admin",
      requiresAuth: true,
    },
  },
  {
    path: "department",
    name: "Departments",
    components: {
      default: DepartmentList,
      menu: AdminToolMenu,
      departments: DepartmentList,
      departmentDetail: DepartmentDetail,
      events: AllEventList,
      trackevents: EventTrackList,
      logevents: LogLayout,
      tarfHistory: TarfHistoryLayout,
      budget: CompanyBudgetLayout,
      roomSetup: RoomSetupLayout,
      handbookLayout: HandbookLayout,
      shiftList: ShiftList,
      shiftDetail: ShiftDetail,
    },
    meta: {
      title: "Company Departments",
      requiresAuth: true,
    },
  },
  {
    path: "department/:id",
    name: "Department Detail",
    components: {
      default: DepartmentDetail,
      menu: AdminToolMenu,
      departments: DepartmentList,
      departmentDetail: DepartmentDetail,
      events: AllEventList,
      trackevents: EventTrackList,
      logevents: LogLayout,
      tarfHistory: TarfHistoryLayout,
      budget: CompanyBudgetLayout,
      roomSetup: RoomSetupLayout,
      handbookLayout: HandbookLayout,
      shiftList: ShiftList,
      shiftDetail: ShiftDetail,
    },
    meta: {
      title: "Department Detail",
      requiresAuth: true,
    },
  },
  // Event Matrics router paths
  {
    path: "event/all",
    name: "All Event List",
    components: {
      default: AllEventList,
      menu: AdminToolMenu,
      departments: DepartmentList,
      departmentDetail: DepartmentDetail,
      events: AllEventList,
      trackevents: EventTrackList,
      logevents: LogLayout,
      tarfHistory: TarfHistoryLayout,
      budget: CompanyBudgetLayout,
      roomSetup: RoomSetupLayout,
      handbookLayout: HandbookLayout,
      shiftList: ShiftList,
      shiftDetail: ShiftDetail,
    },
    meta: {
      title: "All Event",
      requiresAuth: true,
    },
  },
  {
    path: "event/track",
    name: "Event Track List",
    components: {
      default: EventTrackList,
      menu: AdminToolMenu,
      departments: DepartmentList,
      departmentDetail: DepartmentDetail,
      events: AllEventList,
      trackevents: EventTrackList,
      logevents: LogLayout,
      tarfHistory: TarfHistoryLayout,
      budget: CompanyBudgetLayout,
      roomSetup: RoomSetupLayout,
      handbookLayout: HandbookLayout,
      shiftList: ShiftList,
      shiftDetail: ShiftDetail,
    },
    meta: {
      title: "Track Event",
      requiresAuth: true,
    },
  },
  {
    path: "event/log",
    components: {
      default: LogLayout,
      menu: AdminToolMenu,
      departments: DepartmentList,
      departmentDetail: DepartmentDetail,
      events: AllEventList,
      trackevents: EventTrackList,
      logevents: LogLayout,
      tarfHistory: TarfHistoryLayout,
      budget: CompanyBudgetLayout,
      roomSetup: RoomSetupLayout,
      handbookLayout: HandbookLayout,
      shiftList: ShiftList,
      shiftDetail: ShiftDetail,
    },
    meta: {
      title: "Event",
      requiresAuth: true,
    },
    children: [
      {
        path: "",
        components: {
          default: EventDepartmentList,
          departmentList: EventDepartmentList,
          logevent: LogEventList,
        },
        meta: {
          title: "Department List",
          requiresAuth: true,
        },
      },
      {
        path: "logevent/:id",
        components: {
          default: LogEventList,
          departmentList: EventDepartmentList,
          logevent: LogEventList,
        },
        meta: {
          title: "Log Event",
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: "archive_list",
    name: "Employee Archive List",
    components: {
      default: ArchiveEmployeeList,
      menu: AdminToolMenu,
      departments: DepartmentList,
      departmentDetail: DepartmentDetail,
      events: AllEventList,
      trackevents: EventTrackList,
      logevents: LogLayout,
      archiveList: ArchiveEmployeeList,
      tarfHistory: TarfHistoryLayout,
      budget: CompanyBudgetLayout,
      roomSetup: RoomSetupLayout,
      handbookLayout: HandbookLayout,
      categoryList: FavoriteCategoryList,
      shiftList: ShiftList,
      shiftDetail: ShiftDetail,
    },
    meta: {
      title: "Archive List",
      requiresAuth: true,
    },
  },
  {
    path: "favorite_category",
    name: "Favorite Category List",
    components: {
      default: FavoriteCategoryList,
      menu: AdminToolMenu,
      departments: DepartmentList,
      departmentDetail: DepartmentDetail,
      events: AllEventList,
      trackevents: EventTrackList,
      logevents: LogLayout,
      archiveList: ArchiveEmployeeList,
      tarfHistory: TarfHistoryLayout,
      budget: CompanyBudgetLayout,
      roomSetup: RoomSetupLayout,
      handbookLayout: HandbookLayout,
      categoryList: FavoriteCategoryList,
      shiftList: ShiftList,
      shiftDetail: ShiftDetail,
    },
    meta: {
      title: "Archive List",
      requiresAuth: true,
    },
  },
  {
    path: "tarf-history",
    components: {
      default: TarfHistoryLayout,
      menu: AdminToolMenu,
      tarfHistory: TarfHistoryLayout,
      departments: DepartmentList,
      departmentDetail: DepartmentDetail,
      events: AllEventList,
      trackevents: EventTrackList,
      logevents: LogLayout,
      budget: CompanyBudgetLayout,
      roomSetup: RoomSetupLayout,
      handbookLayout: HandbookLayout,
      shiftList: ShiftList,
      shiftDetail: ShiftDetail,
    },
    meta: {
      title: "Tarf History",
      requiresAuth: true,
    },
    children: [
      {
        path: "",
        components: {
          default: TarfHistoryEmployeeList,
          menu: AdminToolMenu,
          employees: TarfHistoryEmployeeList,
          statuses: TarfHistoryStatuses,
          history: TarfHistoryList,
        },
        meta: {
          title: "Employee List",
          requiresAuth: true,
        },
      },
      {
        path: "employee/:id",
        components: {
          default: TarfHistoryStatuses,
          menu: AdminToolMenu,
          employees: TarfHistoryEmployeeList,
          statuses: TarfHistoryStatuses,
          history: TarfHistoryList,
        },
        meta: {
          title: "Tarf Statuses",
          requiresAuth: true,
        },
      },
      {
        path: "employee/:id/tarfs/:status",
        components: {
          default: TarfHistoryList,
          menu: AdminToolMenu,
          employees: TarfHistoryEmployeeList,
          statuses: TarfHistoryStatuses,
          history: TarfHistoryList,
        },
        meta: {
          title: "Tarf list",
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: "company-budget",
    components: {
      default: CompanyBudgetLayout,
      menu: AdminToolMenu,
      departments: DepartmentList,
      departmentDetail: DepartmentDetail,
      events: AllEventList,
      trackevents: EventTrackList,
      logevents: LogLayout,
      archiveList: ArchiveEmployeeList,
      tarfHistory: TarfHistoryLayout,
      budget: CompanyBudgetLayout,
      roomSetup: RoomSetupLayout,
      handbookLayout: HandbookLayout,
      categoryList: FavoriteCategoryList,
      shiftList: ShiftList,
      shiftDetail: ShiftDetail,
    },
    meta: {
      title: "Budget",
      requiresAuth: true,
    },
  },
  {
    path: "company-handbook",
    components: {
      default: HandbookLayout,
      menu: AdminToolMenu,
      departments: DepartmentList,
      departmentDetail: DepartmentDetail,
      events: AllEventList,
      trackevents: EventTrackList,
      logevents: LogLayout,
      archiveList: ArchiveEmployeeList,
      tarfHistory: TarfHistoryLayout,
      budget: CompanyBudgetLayout,
      roomSetup: RoomSetupLayout,
      handbookLayout: HandbookLayout,
      categoryList: FavoriteCategoryList,
      shiftList: ShiftList,
      shiftDetail: ShiftDetail,
    },
    children: [
      {
        path: "",
        components: {
          default: HandbookCategoryList,
          menu: AdminToolMenu,
          handbookCategoryList: HandbookCategoryList,
          CategoryDetails: HandbookCategoryDetail,
        },
        meta: {
          title: "Company Handbook",
          requiresAuth: true,
        },
      },
      {
        path: "details/:categoryId",
        components: {
          default: HandbookCategoryDetail,
          menu: AdminToolMenu,
          handbookCategoryList: HandbookCategoryList,
          CategoryDetails: HandbookCategoryDetail,
        },
        meta: {
          title: "Handbook Category",
          requiresAuth: true,
        },
      },
    ],
    meta: {
      title: "Company Handbook",
      requiresAuth: true,
    },
  },
  {
    path: "room-setup",
    components: {
      default: RoomSetupLayout,
      menu: AdminToolMenu,
      departments: DepartmentList,
      departmentDetail: DepartmentDetail,
      events: AllEventList,
      trackevents: EventTrackList,
      logevents: LogLayout,
      archiveList: ArchiveEmployeeList,
      tarfHistory: TarfHistoryLayout,
      budget: CompanyBudgetLayout,
      roomSetup: RoomSetupLayout,
      handbookLayout: HandbookLayout,
      categoryList: FavoriteCategoryList,
      shiftList: ShiftList,
      shiftDetail: ShiftDetail,
    },
    meta: {
      title: "Room Setup",
      requiresAuth: true,
    },
    children: [
      {
        path: "",
        components: {
          default: FloorList,
          menu: AdminToolMenu,
          floor: FloorList,
          room: RoomList,
          details: RoomDetails,
        },
        meta: {
          title: "Floor List",
          requiresAuth: true,
        },
      },
      {
        path: "floor/:floorId",
        components: {
          default: RoomList,
          menu: AdminToolMenu,
          floor: FloorList,
          room: RoomList,
          details: RoomDetails,
        },
        meta: {
          title: "Room list",
          requiresAuth: true,
        },
      },
      {
        path: "floor/:floorId/room/:roomId",
        components: {
          default: RoomDetails,
          menu: AdminToolMenu,
          floor: FloorList,
          room: RoomList,
          details: RoomDetails,
        },
        meta: {
          title: "Room details",
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: "shift",
    name: "Shifts",
    components: {
      default: ShiftList,
      menu: AdminToolMenu,
      departments: DepartmentList,
      departmentDetail: DepartmentDetail,
      events: AllEventList,
      trackevents: EventTrackList,
      logevents: LogLayout,
      tarfHistory: TarfHistoryLayout,
      budget: CompanyBudgetLayout,
      roomSetup: RoomSetupLayout,
      handbookLayout: HandbookLayout,
      shiftList: ShiftList,
      shiftDetail: ShiftDetail,
    },
    meta: {
      title: "Company Shifts",
      requiresAuth: true,
    },
  },
  {
    path: "shift/:id",
    name: "ShiftDetail",
    components: {
      default: ShiftDetail,
      menu: AdminToolMenu,
      departments: DepartmentList,
      departmentDetail: DepartmentDetail,
      events: AllEventList,
      trackevents: EventTrackList,
      logevents: LogLayout,
      tarfHistory: TarfHistoryLayout,
      budget: CompanyBudgetLayout,
      roomSetup: RoomSetupLayout,
      handbookLayout: HandbookLayout,
      shiftList: ShiftList,
      shiftDetail: ShiftDetail,
    },
    meta: {
      title: "Shift Detail",
      requiresAuth: true,
    },
  },
];

export default routes;
